export class ApiResponse<T> {
    public success: boolean;
    public time: Timestamp;
    public data: T;
}

export class Timestamp {
    public date: string;
    public tz: string;
}